import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductsOfferedComponent } from './products-offered.component';

@NgModule({
    declarations: [ProductsOfferedComponent],
    imports: [CommonModule],
    exports: [ProductsOfferedComponent],
})
export class ProductsOfferedModule {}
